import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["xlink:href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    style: _normalizeStyle({
      width: $options.iconSize,
      height: $options.iconSize
    }),
    "aria-hidden": "true"
  }, [_createElementVNode("use", {
    "xlink:href": $options.iconName
  }, null, 8, _hoisted_1)], 4);
}